import { useState } from "react";
import { Box, Button, Theme } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { TextField as ReusableTextField } from "@flightright/reusable-components";
import { useTranslations as t } from "@/core/hooks/useTranslations/useTranslations";
import getVariableFromString from "@/core/utils/getVariableFromString";
import { useCopyToClipboard } from "@/core/hooks/useCopyToClipboard/useCopyToClipboard";
import { useGetPreviousAnswers } from "@/core/hooks/useGetPreviousAnswers/useGetPreviousAnswers";
import useCustomStyles from "@/core/hooks/useCustomStyles/useCustomStyles";
import { BUTTON_TEXT, BUTTON_VARIANT, ButtonVariant } from "@/core/types/types";
import { FieldProps } from ".";

const DEFAULT_BUTTON_VARIANT = ButtonVariant.Contained;

const styles = (theme: Theme) => ({
  container: {
    display: "flex",
    "& input": {
      backgroundColor: theme.palette.secondary.light,
    },
  },
  button: {
    marginLeft: theme.spacing(1),
    textTransform: "none",
    whiteSpace: "nowrap",
    height: "100%",
    minWidth: 130,
    "&.MuiButton-outlined": {
      backgroundColor: theme.palette.background.default,
    },
  },
});

const CopyTextField = ({ field }: FieldProps) => {
  const classes: any = useCustomStyles(styles);
  const [, copyToClipboard] = useCopyToClipboard();
  const [isSuccess, setSuccess] = useState(false);

  const {
    text,
    properties: { [BUTTON_TEXT]: buttonText, [BUTTON_VARIANT]: buttonVariant },
  } = field;

  // Support rendering a Camunda variable
  const defaultCamundaValue = text && getVariableFromString(text);
  const { result } = useGetPreviousAnswers(defaultCamundaValue, {
    dataIsRequired: false,
  });
  const value = (defaultCamundaValue && result[defaultCamundaValue]) || text;

  const handleCopyButtonClick = (value: string) => {
    const didCopySuccessfully = copyToClipboard(value);
    if (!didCopySuccessfully) return;

    setSuccess(true);

    setTimeout(() => {
      setSuccess(false);
    }, 350);
  };
  return (
    <Box sx={classes?.container}>
      <ReusableTextField
        id={field.key}
        disabled={true}
        value={t(value)}
        size="small"
      />

      <Box>
        <Button
          sx={classes.button}
          variant={buttonVariant || DEFAULT_BUTTON_VARIANT}
          onClick={() => handleCopyButtonClick(value)}
        >
          {isSuccess ? <CheckIcon /> : t(buttonText)}
        </Button>
      </Box>
    </Box>
  );
};

export default CopyTextField;
